<div class="flex flex-col h-full bg-blue-700">
  <div class="flex justify-center px-4  items-center h-16 text-white">
    <h1 class="text-5xl 2xl:text-7xl py-4 font-bold">Turnos Asignados</h1>
  </div>
  <div class="flex-1 flex flex-col text-5xl 2xl:text-7xl">
    <div class="flex-1 flex gap-2 justify-center items-center px-6 bg-blue-800">
      <p class="font-bold">{{ turno1.claveTurno }}</p><p>-</p><p>{{ turno1.puesto }}</p>
    </div>
    <div class="flex-1 flex gap-2 justify-center items-center px-6">
      <p class="font-bold">{{ turno2.claveTurno }}</p><p>-</p><p>{{ turno2.puesto }}</p>
    </div>
    <div class="flex-1 flex gap-2 justify-center items-center px-6 bg-blue-800">
      <p class="font-bold">{{ turno3.claveTurno }}</p><p>-</p><p>{{ turno3.puesto }}</p>
    </div>
    <div class="flex-1 flex gap-2 justify-center items-center px-6">
      <p class="font-bold">{{ turno4.claveTurno }}</p><p>-</p><p>{{ turno4.puesto }}</p>
    </div>
  </div>
</div>
